import { IEndpointData } from '@packages/toolbox/dist/declarations/endpoint';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';

export const reportsUrl = `${SERVER_API}/report-kinds`;
export const reportsUrlBasic = `${reportsUrl}/basic`;
export const reportsUrlGasu = `${reportsUrl}/gasu`;
export const reportsUrlGrants = `${reportsUrl}/grants`;
export const reportsUrlDesorganized = `${reportsUrl}/desorganized`;

export const REPORTS = {
  KINDS: {
    ...generateCrudEndpoints(`${reportsUrl}`),
    SET_ACTIVE_FORM(id: number): IEndpointData {
      return {
        method: 'PUT',
        url: `${reportsUrl}/${id}/set-active-form`,
      };
    },
    GET_REPORTING_DATES(id: number): IEndpointData {
      return {
        method: 'GET',
        url: `${reportsUrl}/${id}/reporting-dates`,
      };
    },
  },

  REPORTS: {
    LIST: {
      method: 'GET',
      url: `${reportsUrl}/reports`,
    } as IEndpointData,
    GET(reportKindId: number, reportId: number): IEndpointData {
      return {
        method: 'GET',
        url: `${reportsUrl}/${reportKindId}/reports/${reportId}`,
      };
    },
    UPDATE(reportKindId: number, reportId: number): IEndpointData {
      return {
        method: 'PUT',
        url: `${reportsUrl}/${reportKindId}/reports/${reportId}`,
      };
    },
    DELETE(reportKindId: number, reportId: number): IEndpointData {
      return {
        method: 'DELETE',
        url: `${reportsUrl}/${reportKindId}/reports/${reportId}`,
      };
    },
    STORE(reportKindId: number): IEndpointData {
      return {
        method: 'POST',
        url: `${reportsUrl}/${reportKindId}/reports`,
      };
    },
    HISTORY(reportKindId: number, reportId: number): IEndpointData {
      return {
        method: 'GET',
        url: `${reportsUrl}/${reportKindId}/reports/${reportId}/history`,
      };
    },
    UPDATE_STATUS(reportKindId: number, reportId: number): IEndpointData {
      return {
        method: 'PUT',
        url: `${reportsUrl}/${reportKindId}/reports/${reportId}/status`,
      };
    },
    STATUS_HISTORY(reportKindId: number, reportId: number): IEndpointData {
      return {
        method: 'GET',
        url: `${reportsUrl}/${reportKindId}/reports/${reportId}/status-history`,
      };
    },
    EXPORT(reportKindId: number, reportId: number): IEndpointData {
      return {
        method: 'GET',
        url: `${reportsUrl}/${reportKindId}/reports/${reportId}/export`,
      };
    },
    TEMPLATE(reportKindId: number, reportId: number): IEndpointData {
      return {
        method: 'GET',
        url: `${reportsUrl}/${reportKindId}/reports/${reportId}/template`,
      };
    },
    IMPORT(reportKindId: number, reportId: number): IEndpointData {
      return {
        method: 'POST',
        url: `${reportsUrl}/${reportKindId}/reports/${reportId}/import`,
      };
    },
    /**
     * reportsBaseUrl уже содержит группу и вид: /report-kinds/{group}/{kindId}/reports
     */
    SIGN_FILE(reportsBaseUrl: string, reportId: number): IEndpointData {
      return {
        method: 'POST',
        url: `${reportsBaseUrl}/${reportId}/sign-file`,
      };
    },
    FILL(reportKindId: number, reportId: number): IEndpointData {
      return {
        method: 'PUT',
        url: `${reportsUrl}/${reportKindId}/reports/${reportId}/fill`,
      };
    },
    FILL_ASYNC(reportKindId: number, reportId: number): IEndpointData {
      return {
        method: 'PUT',
        url: `${reportsUrl}/${reportKindId}/reports/${reportId}/fill-async`,
      };
    },
    FILL_INTEGRATION(reportKindId: number, reportId: number): IEndpointData {
      return {
        method: 'PUT',
        url: `${reportsUrl}/${reportKindId}/reports/${reportId}/fill-integration`,
      };
    },
  },

  FORMS: {
    LIST: {
      method: 'GET',
      url: `${reportsUrl}/forms`,
    } as IEndpointData,
    GET(reportKindId: number, formId: number): IEndpointData {
      return {
        method: 'GET',
        url: `${reportsUrl}/${reportKindId}/forms/${formId}`,
      };
    },
  },
};
